import { memo } from "react";
import { styled } from "../../../../lib/styled";
import { feedOutcomeCounts } from "../../../../lib/corpusFeedView";
import type { CorpusFeedStatistics } from "@shared/types/corpus/api.ts";
import { Facts } from "../../../primitives/data-display/Facts";
import { FeedOutcomeSwatch } from "./FeedOutcomeSwatch";

const Dot = styled(FeedOutcomeSwatch)(({ theme }) => ({
  width: theme.spacing(1),
  height: theme.spacing(1),
  borderRadius: "50%",
  marginRight: theme.spacing(1),
}));

interface FeedOutcomeLegendProps {
  statistics: CorpusFeedStatistics;
}

/** What became of the papers a feed returned, as a count for each kind of outcome, each marked
 *  with the colour the outcome bar draws it in. */
export const FeedOutcomeLegend = memo(function FeedOutcomeLegend({
  statistics,
}: FeedOutcomeLegendProps) {
  return (
    <Facts
      items={feedOutcomeCounts(statistics).map((outcome) => ({
        label: (
          <>
            <Dot $outcome={outcome.key} />
            {outcome.label}
          </>
        ),
        value: outcome.count.toLocaleString(),
      }))}
    />
  );
});
